import AssignmentBrief from './TabContent/AssignmentBrief/AssignmentBrief'
import Activities from './TabContent/Activities/Activities'
import Content from './TabContent/Content/Content'
import LinkedItems from './TabContent/LinkedItems'
import { FieldKeys } from './AssignmentDetails'
import { OrderStatusLog } from 'components/workflows/OrderStatusLog'

type Props = {
  projectBrief: FieldKeys[]
  assignmentBrief: FieldKeys[]
  projectFormFields: BackendFormField[]
  content: string
  id: string
  data: Assignment
  refetch: () => void
  callBacks?: {
    setTotalRecentActivity: (value: number) => void
  }
}

const RouteManagement = ({
  id,
  data,
  refetch,
  callBacks,
  content,
  projectBrief,
  assignmentBrief,
  projectFormFields,
}: Props): JSX.Element | null => {
  switch (content) {
    case 'brief': {
      return (
        <AssignmentBrief
          data={data}
          isPage={false}
          projectBrief={projectBrief}
          assignmentBrief={assignmentBrief}
        />
      )
    }

    case 'content': {
      return (
        <Content
          data={data}
          assignmentId={id}
          projectBrief={projectBrief}
          assignmentBrief={assignmentBrief}
        />
      )
    }

    case 'activities': {
      return (
        <Activities
          projectFormFields={projectFormFields}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          assignmentBrief={assignmentBrief as any[]}
          keepSamePage={true}
          id={id}
          data={data}
          refetch={refetch}
          callBacks={callBacks}
        />
      )
    }

    case 'linked-items': {
      if (!data?.group_id) return null

      return (
        <LinkedItems
          groupId={data.group_id}
          assignmentId={data.id}
          projectId={data.project.id}
        />
      )
    }

    case 'workflow-log': {
      return <OrderStatusLog itemId={data.id} />
    }

    default: {
      return null
    }
  }
}

export default RouteManagement
